import { ExtraApp } from "../../../../features/ExtraApp";
import { ExtraAppPage } from "../../../../pages/ExtraAppPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const extraAppsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.ai_agents_extra_app.root,
  element: <ExtraAppPage />,
  name: "Мини-приложения",
  children: appRouterPaths.ai_agents_extra_app.item
    ? [
        {
          path: appRouterPaths.ai_agents_extra_app.item,
          element: <ExtraApp />,
          name: "Мини-приложение",
        },
      ]
    : undefined,
};
